import auth from "./slices/auth";
import current from "./slices/currentPage";
import tank from "./slices/tank";
import depth from "./slices/treeDepth";
import currentDep from "./slices/currentDep";
import filter from "./slices/filter";
import filterHistory from "./slices/filterHistory";

const rootReducer = {
  auth,
  current,
  tank,
  depth,
  currentDep,
  filter,
  filterHistory,
};

export default rootReducer;
